

import UserActivity from "../Peoples/UserActivity";

const item = ({ userAvatarUrl, userName }) => {
  return `
        <div class="contributore-flex-container">
        <div class="contributores-avatar-holder">
          <div class="contributore-avatar">
            <img src="${userAvatarUrl}" alt="avatar">
          </div>
        </div>
          <div class="contributore-name">
            <span>${userName}</span>
            <div class="user-activity-container"></div>
          </div>
          <div class="">
            <div class="buttn primary" data-lang="invite-text">Invite</div>
          </div>
      </div>
`}

export class ChessInvite {
  constructor({ model, socket }) {
    this.model = model;
    this.socket = socket;
    this.wrapper = $(".chess_invite_modal");
    this.list = this.wrapper.find("#chess_invite_list");
    this.input = this.wrapper.find("#chess_invite_input");
    this.contributors = [];
    this._filterUsersHandler = null;
  }

  show(chessGame) {
    const filterUsers = () => {
      // destroy previous activity instances before re-render
      this.destroyContributors();

      const filterValue = String(this.input.val() || '').toLowerCase();
      const filteredUsers = this.socket
        .getUsers()
        .filter(user => user.userId !== this.model.config.userId)
        .filter(user => {
          if (!filterValue) return true;
          return String(user.userName || '').toLowerCase().includes(filterValue);
        });
      this.list.empty();
      if (!filteredUsers.length) {
        // nothing to render, ensure clean state
        return;
      }
      filteredUsers.forEach(user => {
        const _item = $(item(user));
        let state = 'none';
        const occupiedSeats = typeof this.model.socket.getOccupiedSeatsAsArray === 'function'
          ? this.model.socket.getOccupiedSeatsAsArray()
          : [];

        const isInMeeting = occupiedSeats.includes(user.userId);
        const isInTour = this.model.isUserInTour(user.userId);
        const isInChessRoom = this.model.isUserInChessRoom(user.userId);
        const isPlayingChess = this.model.isUserPlayingChess(user.userId);

        if (isInMeeting) {
          state = 'meeting';
        } else if (isInTour) {
          state = 'tour';
        } else if (isInChessRoom || isPlayingChess) {
          state = 'chess';
        }
        const userActivity = new UserActivity({ activeState: state, container: _item.find('.user-activity-container') });
        this.contributors.push(userActivity);

        this.list.append(_item);
        _item.find(".buttn").on("click", () => {
          if (state !== 'none') {
            if (user.isGuest) {
              this.model.alert("error", $trans('error-requested-user-action'));
              return;
            }
            this.model.confirm($trans('user-in-activity-error-text'), () => {
              this.model.createAndOpenChat(user);
              this.hide();
            }, { header: true, title: $trans("user-in-activity-error-text-message"), message: $trans('user-in-activity-error-text-message'), confirmBtnTxt: $trans('send-as-message-text'), cancelBtnTxt: $trans('cancel-text') });
            return;
          }
          this.model.info("success", `${user.userName} ${$trans('chess-game-invitation-sent-text')}`);
          this.model.socket.inviteToChessGame(user.userId, chessGame.gameId);
          this.hide();
        });
      });
    };

    this._filterUsersHandler = filterUsers;
    this.input.on('input', this._filterUsersHandler);

    this.wrapper.addClass("is-active");
    filterUsers(); // Call initially to populate with all users
  }
  hide() {
    // cleanup listeners and instances
    if (this._filterUsersHandler) {
      this.input.off('input', this._filterUsersHandler);
      this._filterUsersHandler = null;
    }
    this.destroyContributors();
    this.list.empty();
    this.wrapper.removeClass("is-active");
  }
  destroyContributors() {
    if (Array.isArray(this.contributors) && this.contributors.length) {
      this.contributors.forEach(instance => {
        try {
          if (instance && typeof instance.destroy === 'function') {
            instance.destroy();
          }
        } catch (e) {
          // swallow to ensure full cleanup
        }
      });
    }
    this.contributors = [];
  }
}